import {
  Location,
  NavigateFunction,
  Params,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom"

export interface RouterProps {
  location: Location<any>
  navigate: NavigateFunction
  params: Params
}

// Higher Order Component (HOC) that adds router props
function WithRouter<P>(
  Component: React.ComponentType<P & { router?: RouterProps }>
) {
  function ComponentWithRouterProp(props: P) {
    let location = useLocation()
    let navigate = useNavigate()
    let params = useParams()

    return <Component {...props} router={{ location, navigate, params }} />
  }

  return ComponentWithRouterProp
}

export default WithRouter
